// Assign practices in their displayed order. Keep empty months in the payload:
// the existing Stripe schedule converter advances one interval per phase.
export function buildUpsellRollout(rows, locations) {
  const active = rows.filter(row => Number(row.count) > 0);
  if (!active.some(row => row.month > 1)) return null;
  if (!active.some(row => row.month === 1)) {
    throw new Error('Assign at least one practice to Month 1.');
  }
  if (rows.some(row => !Number.isInteger(Number(row.count)) || Number(row.count) < 0)) {
    throw new Error('Enter a whole number of practices for each rollout month.');
  }
  if (active.reduce((sum, row) => sum + Number(row.count), 0) !== locations.length) {
    throw new Error('Assign every selected practice to the rollout exactly once.');
  }
  let offset = 0;
  return Array.from({ length: Math.max(...active.map(row => row.month)) }, (_, month) => {
    const count = Number(rows.find(row => row.month === month + 1)?.count) || 0;
    const locationIndices = locations.slice(offset, offset + count).map(location => location.index);
    offset += count;
    return { month, interval: 'month', locationIndices };
  });
}
